import React, { FC, ComponentProps as CP } from 'react'
import marked from 'marked'
import { Typography } from '@material-ui/core'

type Props = Pick<CP<typeof Typography>, 'variant' | 'className'> & {
  lexer?: 'inline'
  markdown?: string | null
}

const MarkdownTypography: FC<Props> = ({ markdown, lexer, ...props }) => {
  const renderer = new marked.Renderer()
  renderer.text = value => value.replace(/&amp;/g, '&')
  if (lexer === 'inline') {
    renderer.paragraph = value => value
  }

  return (
    <Typography
      component="div"
      {...props}
      dangerouslySetInnerHTML={{
        __html: marked(markdown || '', { renderer, smartypants: true }),
      }}
    />
  )
}

export default MarkdownTypography
try {
    // @ts-ignore
    MarkdownTypography.displayName = "MarkdownTypography";
    // @ts-ignore
    MarkdownTypography.__docgenInfo = { "description": "", "displayName": "MarkdownTypography", "props": { "className": { "defaultValue": null, "description": "", "name": "className", "required": false, "type": { "name": "string" } }, "variant": { "defaultValue": null, "description": "", "name": "variant", "required": false, "type": { "name": "\"h1\" | \"h2\" | \"h3\" | \"h4\" | \"h5\" | \"h6\" | \"subtitle1\" | \"subtitle2\" | \"body1\" | \"body2\" | \"caption\" | \"button\" | \"overline\" | \"inherit\" | \"srOnly\"" } }, "lexer": { "defaultValue": null, "description": "", "name": "lexer", "required": false, "type": { "name": "\"inline\"" } }, "markdown": { "defaultValue": null, "description": "", "name": "markdown", "required": false, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/MarkdownTypography/MarkdownTypography.tsx#MarkdownTypography"] = { docgenInfo: MarkdownTypography.__docgenInfo, name: "MarkdownTypography", path: "src/components/MarkdownTypography/MarkdownTypography.tsx#MarkdownTypography" };
}
catch (__react_docgen_typescript_loader_error) { }